// extracted by mini-css-extract-plugin
module.exports = {"contentsItem":"PlasmicListItem_contentsItem__Pz722","icon":"PlasmicListItem_icon__Nu7TF","svg__rg9Cj":"PlasmicListItem_svg__rg9Cj__K9ZSZ","text16":"PlasmicListItem_text16__3ogM8"};